import {Typography} from "@mui/material";
import {useTranslation} from "next-i18next";
import {slugify} from "../../../lib/util";


export const tripDetailTitles = {
    "en": ["why we love it", "conservation", "who is it for?", "prices and dates", "dive briefing!", "visas, flights, and more!"],
    "fr": ["pourquoi on aime!", "conservation", "c'est pour qui?", "prix et dates", "le brief plongée!", "visa, vols et plus!"],
    "es": ["¿por qué nos encanta?", "conservación", "¿para quién es?", "precios y fechas", "¡briefing de buceo!", "¡visados, vuelos, y más!"]
}

export function TripDetailHeading(props: any) {

    const {i18n} = useTranslation()

    let slug = "";
    if (typeof props.children === "string") {
        const idx = tripDetailTitles[i18n.language as keyof typeof tripDetailTitles]?.indexOf(props.children.toLowerCase())

        // console.log(idx)
        if (idx > -1) {
            slug = slugify(tripDetailTitles["en"][idx])
        }
    }

    return <>
        {slug && <>
            <span id={slug}
                  style={{
                      paddingTop: 70,
                      marginTop: -70,
                      display: "inline-block"
                  }}
            ></span>
            <a href={`#${slug}`}
               style={{
                   paddingTop: 70,
                   marginTop: -70,
                   display: "inline-block"
               }}/>
        </>}
        <Typography variant={"h5"}>{props.children}</Typography>

    </>
}
